import {
  DUCK_DROP_MS,
  DUCK_HOLD_MS,
  DUCK_LOW_END,
  DUCK_RISE_MS,
} from "../constants";

export type DuckPhase = "dropping" | "holding" | "rising";

export function duckClearsBranch(
  phase: DuckPhase,
  phaseMs: number,
  riseMs = DUCK_RISE_MS,
): boolean {
  if (phase === "holding" || phase === "dropping") {
    return true;
  }
  return phaseMs < riseMs * DUCK_LOW_END;
}

export function advanceDuckPhase(
  phase: DuckPhase,
  phaseMs: number,
  dropMs = DUCK_DROP_MS,
  holdMs = DUCK_HOLD_MS,
  riseMs = DUCK_RISE_MS,
): { phase: DuckPhase; phaseMs: number } | "done" {
  if (phase === "dropping" && phaseMs >= dropMs) {
    return { phase: "holding", phaseMs: phaseMs - dropMs };
  }
  if (phase === "holding" && phaseMs >= holdMs) {
    return { phase: "rising", phaseMs: 0 };
  }
  if (phase === "rising" && phaseMs >= riseMs) {
    return "done";
  }
  return { phase, phaseMs };
}
